// extracted by mini-css-extract-plugin
module.exports = {"icon":"WechatIcon_icon_2mFBQ","wechat":"WechatIcon_wechat_HQsqo"};